import { render, staticRenderFns } from "./ViewNews.vue?vue&type=template&id=0db8e6a5&scoped=true&"
import script from "./ViewNews.vue?vue&type=script&lang=js&"
export * from "./ViewNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db8e6a5",
  null
  
)

export default component.exports